import * as views from "../views";

export default [
  {
    path: "account/uninstall",
    name: "Uninstall",
    component: views.Uninstall,
  }
];
